import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NewAddedCategoriesService {

  
  constructor(private apiService:ApiService) { }


 getNewAddedCategories(queryParams: HttpParams) {
  return this.apiService.get('categories/new', queryParams);
}
  

}
